import React, { useEffect, useState, useContext } from 'react';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { CREATE_JOB_POSTING_DEFAULTS } from '../../../utils/constants';
import ProgressBar from './TipSections/ProgressBar';
import CompanyDetailsTip from './TipSections/CompanyDetailsTip';
import BusinessDetails from './TipSections/BusinessDetails';
import TemplatesLink from './TipSections/TemplatesLink';
import ProTip from './TipSections/ProTip';
import EditTemplateTip from './TipSections/EditTemplateTip';
import TimeBoundNotification from './TipSections/TimeBoundNotification';

const CreateJobProgress = () => {
  const { editedJobPosting, hasTemplate } = useContext(JobPostingContext);
  const { TRADE_TYPE_BASIC_HEADER, EMPLOYMENT_TYPE_BASIC_HEADER, EXPERIENCE_LEVEL_BASIC_HEADER, PAY_FREQUENCY_BASIC_HEADER } = CREATE_JOB_POSTING_DEFAULTS;

  const [percentage, setPercentage] = useState(0);

  const jobPostingValidators = {
    companyName: ({ companyName }) => !!companyName && companyName?.trim() !== '',
    title: ({ title }) => title?.trim() !== '',
    tradeType: ({ tradeType }) => tradeType !== '' && tradeType !== TRADE_TYPE_BASIC_HEADER,
    employmentType: ({ employmentType }) => employmentType !== '' && employmentType !== EMPLOYMENT_TYPE_BASIC_HEADER,
    yearsOfExperience: ({ yearsOfExperience }) => yearsOfExperience !== '' && yearsOfExperience !== EXPERIENCE_LEVEL_BASIC_HEADER,
    payFrequency: ({ payFrequency }) => payFrequency !== '' && payFrequency !== PAY_FREQUENCY_BASIC_HEADER,
    payRange: ({ payRange }) => !!payRange?.minAmount,
    benefits: ({ benefits }) => benefits?.choices?.length > 0,
    locationText: ({ locationText }) => locationText !== '',
    jobDescription: ({ jobDescription }) => jobDescription?.trim() !== '' && jobDescription?.trim() !== '<p><br></p>' && jobDescription?.trim() !== '<p></p>'
  };

  const validatorCount = Object.keys(jobPostingValidators).length;
  const pointsPerValidator = 100 / validatorCount;

  useEffect(() => {
    let totalPercentage = Object.values(jobPostingValidators)
      .map((validator) => (validator(editedJobPosting) ? pointsPerValidator : 0))
      .reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    setPercentage(Math.round(totalPercentage));
  }, [editedJobPosting]);

  return (
    <div className="create-job-posting__side-bar">
      <div className="create-job-posting__create-job-progress-bar-container">
        <ProgressBar completed={percentage} />
        <CompanyDetailsTip jobPosting={editedJobPosting} />
        <BusinessDetails editedJobPosting={editedJobPosting} />
        <TemplatesLink />
        <EditTemplateTip hasTemplate={hasTemplate} />
        <TimeBoundNotification />
        {jobPostingValidators.jobDescription(editedJobPosting) && <ProTip paragraphDetails={'Candidates prefer complete and concise job postings. Make sure to enter all the information they\'ll need to decide to apply, but keep it to the point.'} />}
        {editedJobPosting?.educationAndSkills !== '' && <ProTip paragraphDetails="Tell candidates if you offer any training opportunities! Candidates may be more likely to apply if they can learn on the job." />}
        <div className="create-job-posting__bottom-spacer" />
      </div>
    </div>
  );
};

export { CreateJobProgress };
